import './tripsList.css';
import {NavLink} from "react-router-dom";
import {format} from "date-fns";
const TripsList = ({data, classes}) => {
    const trips = data ? data : [];
    return(
        <div className={`data-table trips-list-table font-15 ${classes}`}>
            <ul className="table-row sf-medium table-header light-back border-radius-8">
                <li className={'from'}>From</li>
                <li className={'to'}>To</li>
                <li className={'distance'}>Distance</li>
                <li className={'duration'}>Duration</li>
                {/*<li className={'fuel-consumed'}>Fuel Consumed</li>*/}
                <li className={'alerts'}>Alerts</li>
                <li className={'date-time'}>Date & Time</li>
                <li className={'score'}>Score</li>
                <li className={'number-plate'}>Vehicle Plate No</li>
            </ul>
            {
                trips.map((trip) =>
                    <ul key={trip._id} className="table-row padding-tb-10 sf-medium border-bottom">
                        <li className={'from'}>
                            <div className="">
                                <NavLink to={`${trip}`} className="highlight-color ">
                                    <div className="text-ellipsis">{trip.decodedStartLocation}</div>
                                </NavLink>
                                <div className="tooltip width-200">{trip.decodedStartLocation}</div>
                            </div>

                        </li>
                        <li className={'to'}>
                            <div className="">
                                <NavLink to={`${trip}`} className="highlight-color ">
                                    <div className="text-ellipsis">{trip.decodedEndLocation}</div>
                                </NavLink>
                                <div className="tooltip width-200">{trip.decodedEndLocation}</div>
                            </div>
                        </li>
                        <li className={'distance'}>{(trip.distance.value / 1000).toFixed(1)} Kms</li>
                        <li className={'duration'}>{(trip.duration.value / (1000 * 60 * 60)).toFixed(1)} Hrs</li>
                        {/*<li className={'fuel-consumed'}>80 Ltrs</li>*/}
                        <li className={'alerts'}>
                            {trip?.casAlerts + trip?.fmsAlerts + trip?.dmsAlerts}
                        </li>
                        <li className={'date-time'}>
                            {format(new Date(`${trip.startDate} ${trip.startTime}`), 'MMM dd hh:mm')}
                            <span> - </span>
                            {format(new Date(`${trip.endDate} ${trip.endTime}`), 'MMM dd hh:mm')}
                        </li>
                        {/*<li className={'date-time'}>Aug 28  9:36 - Aug 29 13:05</li>*/}
                        <li className={'date-time flex'}>
                            <div className="progress-bar item-height-6 width-60">
                                <div className="completed"></div>
                            </div>
                            <div className="margin-l-10">4.8</div>
                        </li>
                        <li className={'number-plate'}>{trip.vehicle.plateNo}</li>
                    </ul>
                )
            }
        </div>
    )
}

export default TripsList;
